import {
  AUTH_EVENTS,
  AUTH_EVENT_PARAM,
  SOURCE_QUERY_PARAM,
} from '@move-auth/shared';

export default ({
  path,
  fragment,
  sourceUrl,
  authEvent = AUTH_EVENTS.USER_LOGOUT,
}) => {
  const { origin, pathname, searchParams, hash } = new URL(
    sourceUrl || window.location.href
  );

  searchParams.append(AUTH_EVENT_PARAM, authEvent);

  const encodedSourceUrl = encodeURIComponent(
    `${origin}${pathname}?${searchParams.toString()}${
      fragment ? `#${fragment}` : hash || ''
    }`
  );

  return `${origin}${path}?${SOURCE_QUERY_PARAM}=${encodedSourceUrl}`;
};
